
//Représente les données d’un tree view item
export class DonneesTreeViewItem 
{
  //Identifiant
  public identifiant!: number;

  //Texte
  public texte!: string;

  //Niveau
  public niveau!: number;

  //Sous item
  public items?: DonneesTreeViewItem[];
}